import React from 'react'
import { IconReceipt,IconReceiptOff,IconReceiptDollar } from '@tabler/icons-react'
export default function PaymentStatusIcon(status) {
    if(status === "received") return  (<IconReceiptDollar color='green'/>)
    if(status === "canceled") return <IconReceiptOff color='red'/>
    if(status === "waiting") return <IconReceipt color='orange'/>
}
